module.exports = __webpack_public_path__ + "static/img/1-1.fc149ed.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/selection/pc/components/past-review/1-1.jpg
// module id = yCNB
// module chunks = 25